/* eslint-disable no-undef */
/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import {
  Form,
  message,
  Col,
  Tooltip,
  Collapse,
  Input,
  Popconfirm,
  Select,
  Tabs,
  Button
} from 'antd';
import axios from 'axios';
import { API_DEVICE } from '../../../../../commons/api';
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
  DownOutlined
} from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';
import { connect } from 'react-redux';
import TableSelect from '../../../Widgets/TableSelect';
import {
  submitJobPlan,
  getTaskListByEquipmentandTaskType,
  getTaskById,
  getJobPlanById,
  getStatusListTask,
  getSkillTypeList
} from '../../../Utils/FormCalls';
import {
  StyledCollapse,
  StyledSubForm,
  StyledSubHeading,
  StyledModal,
  StyledBox
} from '../../../CSS/style';
import Highlighter from 'react-highlight-words';
import { StyledHomepage } from '../../../../../commons/styles/layout';
import themeSettings from '../../../../../commons/styles/themeSettings.json';
import {
  ToolsForm,
  LaborForm,
  MaterialForm,
  ItemForm,
  FieldDataType,
  ObservationType
} from './TaskRequirements';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';
import { constant } from '../../../Utils/constants';
import FileBase64 from '../../../Utils/FileUpload';
import InputComponent from '../../../Widgets/InputComponent';
import dayjs from 'dayjs';
const { Panel } = Collapse;
const { Option } = Select;
const { TabPane } = Tabs;

const JobPlanForm = (props) => {
  const formHeader = useRef(null);
  const [TaskList, setTaskList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [SkillTypeList, setSkillTypeList] = useState([]);
  const [fileUploadList, setFileUploadList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedTask, setSelectedTask] = useState('');
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      const SkillTypeList = await getSkillTypeList();
      setSkillTypeList(SkillTypeList);
      const formObject = formHeader.current ? formHeader.current.getFieldsValue() : {};
      if (formHeader.current) formHeader.current.setFieldsValue(formObject);
      setFormObject(formObject);
      const statusList = await getStatusListTask();
      setStatusList(statusList);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);

  const _getDataById = async (jobplanId) => {
    let formObject = formHeader.current.getFieldsValue();
    let path = props.location.pathname.split('/rubus/AMM/JobPlanDetails/');
    let formId = jobplanId ? jobplanId : base64_decode(path[1]);
    if (formId !== 'new') {
      let FormObject = await getJobPlanById(formId, 'withId');
      const TaskList = await getTaskListByEquipmentandTaskType(
        'Active',
        FormObject && FormObject['DeviceAlias']
      );
      setTaskList(TaskList);
      _.cloneDeepWith(formObject, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['StartTime']
              ? (value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss').local())
              : null),
            ...(value['EndTime']
              ? (value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss').local())
              : null),
            ...(value['MeasurementDate']
              ? (value['MeasurementDate'] = dayjs
                .utc(value.MeasurementDate, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['TaskData'] &&
              value['TaskData'].map((item, i) => {
                return value['TaskData'][i]
                  ? value['TaskData'][i]['EstimatedDuration']
                    ? (value['TaskData'][i]['EstimatedDuration'] = dayjs
                      .utc(value['TaskData'][i]['EstimatedDuration'], 'YYYY-MM-DD HH:mm:ss')
                      .local())
                    : null
                  : null;
              }))
          }
          : _.noop();
      });
      setFormObject(FormObject);
      if (formObject) {
        formHeader && formHeader.current.setFieldsValue(FormObject);
      }
    } else if (jobplanId) {
      formObject = await getJobPlanById(jobplanId, 'withId');
      if (formObject && formObject.Type === 'observationType') {
        setFileUploadList({});
      } else {
        setFileUploadList({});
      }
      setFormObject((prev) => {
        return _.cloneDeepWith(prev, (value) => {
          return value && value !== null
            ? {
              ...value,
              ...(value['StartTime']
                ? (value['StartTime'] = dayjs
                  .utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')
                  .local())
                : null),
              ...(value['EndTime']
                ? (value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss').local())
                : null),
              ...(value['MeasurementDate']
                ? (value['MeasurementDate'] = dayjs
                  .utc(value.MeasurementDate, 'YYYY-MM-DD HH:mm:ss')
                  .local())
                : null),
              ...(value['TaskData'] &&
                value['TaskData'].map((item, i) => {
                  return value['TaskData'][i]
                    ? value['TaskData'][i]['EstimatedDuration']
                      ? (value['TaskData'][i]['EstimatedDuration'] = dayjs(
                        value['TaskData'][i]['EstimatedDuration'],
                        'YYYY-MM-DD HH:mm:ss'
                      ))
                      : null
                    : null;
                }))
            }
            : _.noop();
        });
      });
      setFileUploadList({});

    }

  };
  const handleSelect = (value, mainIndex, subindex, keyName, selectedObject) => {
    let skill = SkillTypeList.filter((item) => item.Id === selectedObject[0]['SkillTypeId']);
    let list = formHeader.current.getFieldValue('TaskData');
    let TaskData = [...list];
    TaskData.map((item, index) => {
      if (index === mainIndex) {
        if (keyName === 'Labor') {
          item[keyName][subindex]['SkillTypeId'] =
            skill && skill[mainIndex] && Array.isArray(skill) && skill[mainIndex].Id
              ? skill[mainIndex].Id
              : null;
          item[keyName][subindex]['Description'] = selectedObject[0]['Description'];
          item[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
        } else {
          item[keyName][subindex]['Description'] = selectedObject[0]['Description'];
          item[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
        }
      }
      return item;
    });
    formHeader.current.setFieldsValue({ TaskData });
    setFormObject((prev) => ({ ...prev, TaskData }));
  };

  const taskFileupload = async (values, key, fileDataObject, index, TaskId) => {
    let formObject = formHeader.current.getFieldsValue();
    let updatedTaskData = [...(formObject.TaskData || [])];
    if (updatedTaskData[index] && updatedTaskData[index][key]) {
      updatedTaskData[index][key].push(...values);
    } else if (updatedTaskData[index] !== undefined) {
      updatedTaskData[index][key] = values;
    } else {
      updatedTaskData.push({ [key]: values });
    }
    updatedTaskData = updatedTaskData.map((item) => {
      if (item[key]) {
        item[key] = item[key].reduce((acc, current) => {
          const x = acc.find((item) => item.Name === current.Name);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
      }
      return item;
    });
    formObject = {
      ...formObject,
      TaskData: updatedTaskData,
    };
    let updatedFileUploadList = [...(fileUploadList || [])];
    updatedFileUploadList.push({ fileDataObject, TaskId });
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setFileUploadList(updatedFileUploadList);
  };
  const onFinish = async (values) => {
    if (values && values.TaskData.length > 0) {
      delete values.EquipmentDescription;
      delete formObject.EquipmentDescription;
      let payload = {
        ...formObject,
        ...values,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      let ToolData = null;
      let ManPowerData = null;
      let MaterialData = null;
      let ItemsData = null;
      formObject &&
        formObject.TaskData &&
        Array.isArray(formObject.TaskData) &&
        formObject.TaskData.map((item) => {
          ToolData = item.Tools && item.Tools.includes(null);
          ManPowerData = item.Labor && item.Labor.includes(null);
          MaterialData = item.Materials && item.Materials.includes(null);
          ItemsData = item.Items && item.Items.includes(null);
          return {};
        });
      if (ToolData) {
        message.warn('Please Add Mandatory Fields In Tools');
      } else if (ManPowerData) {
        message.warn('Please Add Mandatory Fields In ManPower');
      } else if (MaterialData) {
        message.warn('Please Add Mandatory Fields In Materials');
      } else if (ItemsData) {
        message.warn('Please Add Mandatory Fields In Items');
      }
      if (
        formObject.TaskData &&
        Array.isArray(formObject.TaskData) &&
        formObject.TaskData.length > 0
      ) {
        if (!ToolData && !ManPowerData && !MaterialData && !ItemsData) {
          let statusResponse = await submitJobPlan(payload, fileUploadList);
          if (statusResponse && statusResponse.Id) {
            // Assuming _getDataById is a function defined elsewhere in your component
            _getDataById(statusResponse.Id);
            setFileUploadList([]);
            if (
              statusResponse.response?.status &&
              (statusResponse.response.status === 400 || statusResponse.response.status === 500)
            ) {
              message.error(statusResponse.response.data.message);
            } else {
              message.success(statusResponse.message);
            }
          } else if (statusResponse && statusResponse.Error) {
            message.error(statusResponse.Error);
          }
        }
      } else {
        message.error('Please Add At Least One Task');
      }
    } else {
      message.error('Please Add At Least One Task');
    }
  };
  const onFinishFailed = () => {
    message.error('Please enter mandatory fields');
  };
  // const onReset = () => {
  //   if (formHeader.current) {
  //     formHeader.current.resetFields();
  //   }
  // };
  // const datepickerchange = (date, dateString, index, key) => {
  //   let formObject = formHeader.current.getFieldsValue();
  //   let EstimatedDuration = null;
  //   if (key === 'EndTime' && formObject.TaskData[index]['StartTime']) {
  //     let startTime = formObject.TaskData[index]['StartTime'];
  //     let endTime = date;
  //     let ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = dayjs.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm:ss');
  //   } else if (key === 'StartTime' && formObject.TaskData[index]['EndTime']) {
  //     let endTime = formObject.TaskData[index]['EndTime'];
  //     let startTime = date;
  //     let ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = dayjs.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm:ss');
  //   }
  //   if (formObject.TaskData[index]) {
  //     formObject.TaskData[index]['EstimatedDuration'] = EstimatedDuration;
  //   }
  //   formHeader.current.setFieldsValue(formObject);
  // };
  // const getDisabledHours = (e, index, key) => {
  //   let hours = [];
  //   let minutes = [];
  //   let StartDateTime = '';
  //   let EndDateTime = '';
  //   let StartDate = '';
  //   let EndDate = '';
  //   if (key === 'StartTime') {
  //     StartDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
  //     EndDateTime = dayjs.utc(formHeader.current.getFieldValue().TaskData[index]?.EndTime, 'YYYY-MM-DD HH:mm').local();
  //     StartDate = dayjs(e).format('YYYY-MM-DD');
  //     EndDate = dayjs.utc(formHeader.current.getFieldValue().TaskData[index]?.EndTime).local().format('YYYY-MM-DD');
  //   } else if (key === 'EndTime') {
  //     StartDateTime = dayjs.utc(formHeader.current.getFieldValue().TaskData[index]?.StartTime, 'YYYY-MM-DD HH:mm').local();
  //     EndDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
  //     StartDate = dayjs.utc(formHeader.current.getFieldValue().TaskData[index]?.StartTime).local().format('YYYY-MM-DD');
  //     EndDate = dayjs(e).format('YYYY-MM-DD');
  //   }
  //   if (key === 'StartTime' && dayjs(StartDate).isSame(dayjs(EndDate))) {
  //     for (let i = 0; i <= 24; i++) {
  //       if (i > dayjs(EndDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (dayjs(StartDate).isSame(dayjs(EndDate))) {
  //       for (let j = 0; j <= 60; j++) {
  //         if (j > dayjs(EndDateTime).minutes() - 1) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //     };
  //   } else if (key === 'EndTime' && dayjs(StartDate).isSame(dayjs(EndDate))) {
  //     for (let j = 0; j < dayjs(StartDateTime).hours(); j++) {
  //       if (j < 25) {
  //         hours.push(j);
  //       }
  //     }
  //     if (dayjs(StartDate).isSame(dayjs(EndDate))) {
  //       for (let k = 0; k < dayjs(StartDateTime).minutes() + 1; k++) {
  //         if (k < 61) {
  //           minutes.push(k);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes,
  //     };
  //   }
  // };
  const TaskOnChange = async (value) => {
    let formObject = formHeader.current.getFieldValue();
    let TaskData = await getTaskById(value, 'withoutId');
    if (TaskData) {
      let data = formObject.TaskData || [];
      _.cloneDeepWith(TaskData, (value) => {
        return value !== undefined && value !== null
          ? {
            ...value,
            ...(value['StartTime']
              ? (value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['EndTime']
              ? (value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['MeasurementDate']
              ? (value['MeasurementDate'] = dayjs.utc(
                value.MeasurementDate,
                'YYYY-MM-DD HH:mm:ss'
              ))
              : null),
            ...(value['EstimatedDuration']
              ? (value['EstimatedDuration'] = dayjs(
                value.EstimatedDuration,
                'YYYY-MM-DD HH:mm:ss'
              ))
              : null)
          }
          : _.noop();
      });
      data.push(TaskData);
      formObject = {
        ...formObject,
        TaskData: data
      };
      formHeader.current.setFieldsValue(formObject);
      setSelectedTask(value);
      setFormObject(formObject);
    }
  };
  // hierarchyDropdownChange = (value, mainindex) => {
  //   // let formObject = this.formHeader.current.getFieldsValue()
  //   // formObject = {
  //   //     ...formObject,
  //   //     "DeviceCode": value.Code,
  //   //     "EquipmentDescription": value.Name,
  //   // }
  //   // this.formHeader.current.setFieldsValue(formObject)
  //   let { formObject } = this.state;
  //   let list = this.formHeader.current.getFieldValue('TaskData');
  //   let TaskData = list;
  //   TaskData.map((item, index) => {
  //     if (index === mainindex) {
  //       item.DeviceCode = value.Code;
  //     }
  //     return {};
  //   });
  //   formObject = {
  //     ...formObject,
  //     TaskData: TaskData
  //   };
  //   this.setState({
  //     visible: false,
  //     formObject
  //   });
  //   this.formHeader.current.setFieldsValue({ TaskData: TaskData });
  // };
  const onDrawerCancel = () => {
    setVisible(false);
  };
  // const translation = (keyword) => {
  //   let { translationCache } = props;
  //   return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  // };
  // const getValueFromList = (list, compareKey, compareValue, resultKey) => {
  //   let filterObject = [];
  //   if (list && Array.isArray(list)) {
  //     filterObject = list.filter((listObject) => listObject[compareKey] === compareValue);
  //   }
  //   return filterObject && filterObject[0] && filterObject[0][resultKey]
  //     ? filterObject[0][resultKey]
  //     : '';
  // };
  // const onTaskSelection = (val) => {
  //   if (val === 'observationType') {
  //     // setViewObservationType(true);
  //     setViewfieldDataType(false);
  //   } else {
  //     // setViewfieldDataType(true);
  //     setViewObservationType(false);
  //   }
  // };
  // const ObservationCancel = () => {
  //   setViewObservationType(false);
  // };
  // const ObservationOK = () => {
  //   setViewObservationType(false);
  // };
  // const getHierarchyLevels = () => {
  //   const siteId = localStorage.get('currentSite');
  //   let payload = {
  //     HierarchyCode: hierarchyList && Array.isArray(hierarchyList) && hierarchyList[0] ? hierarchyList[0].HierarchyCode : null,
  //     Type: 'Device',
  //   };
  //   const accessToken = localStorage.get('accessToken');
  //   let headers = {
  //     method: 'GET',
  //     url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${payload.HierarchyCode}&Type=${payload.Type}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //   };
  //   axios(headers)
  //     .then(({ data }) => {
  //       if (Array.isArray(data)) {
  //         setTreeData(data);
  //         setVisible(true);
  //         setFormObject(formHeader.current.getFieldsValue());
  //       }
  //     })
  //     .catch((error) => {
  //       message.error(error);
  //     });
  // };
  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setVisible(true);
        setFormObject(formHeader.current.getFieldsValue());
      })
      .catch(function () {
        message.error('Failed to fetch device data');
      });
  };
  const TableDropdownChange = async (value) => {
    const TaskList = await getTaskListByEquipmentandTaskType('Active', value.AliasCode);
    setTaskList(TaskList);

    let formObject = formHeader.current.getFieldsValue();
    formObject = {
      ...formObject,
      Equipment: value.AliasCode,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      EquipmentDescription: value.Name
    };
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setSelectedTask('');
    setVisible(false);
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const removeTask = (key) => {
    let formObject = formHeader.current.getFieldValue();
    formObject = {
      ...formObject,
      TaskData: formObject.TaskData.filter((task, index) => index !== key),
      TaskName: null
    };
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setSelectedTask('');
  };
  const add = (taskIndex, key) => {
    let formObject = formHeader.current.getFieldsValue();
    formObject = {
      ...formObject,
      TaskData: formObject.TaskData.map((task, index) => {
        if (index === taskIndex) {
          let reqArray = task && task[key] ? task[key] : [];
          reqArray.push(null); // Add a new empty object
          return { ...task, [key]: reqArray };
        }
        return task;
      })
    };
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };
  const remove = (taskIndex, toolIndex, key) => {
    let formObject = formHeader.current.getFieldsValue();
    let ToolsList = formObject.TaskData[taskIndex][key];
    if (ToolsList) {
      let Tools = ToolsList.filter((_, index) => toolIndex !== index);
      formObject = {
        ...formObject,
        TaskData: formObject.TaskData.map((tasks, index) => {
          if (index === taskIndex) {
            return { ...tasks, [key]: Tools };
          }
          return tasks;
        })
      };
      formHeader.current.setFieldsValue(formObject);
      setFormObject(formObject);
    }
  };
  const children = [];
  for (let i = 10; i < 36; i++) {
    children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
  }
  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };
  const styledCollapse = (formObject, key, translationCache) => (
    <span>
      <span style={{ fontWeight: 'bold' }}>{translation(translationCache, 'Task Name')}</span> :
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {formObject['TaskData'] &&
          formObject['TaskData'][key] &&
          formObject['TaskData'][key]['TaskName']
          ? formObject['TaskData'][key]['TaskName']
          : ''}
      </span>
      <span style={{ fontWeight: 'bold' }}>
        {translation(translationCache, 'Task Description')}
      </span>{' '}
      :
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {formObject['TaskData'] &&
          formObject['TaskData'][key] &&
          formObject['TaskData'][key]['TaskDescription']
          ? formObject['TaskData'][key]['TaskDescription']
          : ''}
      </span>
    </span>
  );
   const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
 
  return (
    <StyledHomepage>
      <Form
        name="jobplan"
        ref={formHeader}
        initialValues={formObject}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBox  themeBackground={themeBackground} style={{ padding: "20px" }}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item name="Id" rules={[{ required: false }]}></Form.Item>
            <Form.Item
              label={translation(translationCache, constant.jobPlan)}
              name="JobPlanName"
              style={{
                width: '100%',
                flex: '50%'
              }}
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(translationCache, 'Enter JobPlan')}
                value={formObject && formObject.JobPlanName ? formObject.JobPlanForm : ''}
                style={{ width: '70%' }}
                //maxLength={30}
                disabled={formObject && formObject.Id ? true : false}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.jobPlanDescription)}
              name="JobPlanDescription"
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true }]}
            >
              <InputComponent
                //maxLength={100}
                placeholder={translation(translationCache, 'Enter Description')}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%'
              }}
              label={translation(translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <Input
                //maxLength={150}
                style={{ width: '70%' }}
                disabled={true}
                placeholder={translation(translationCache, 'Select Equipment')}
                suffix={
                  <DownOutlined
                    style={{
                      // color: '#1a3b5c',
                      color: formObject && formObject.Id ? null : '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   getDeviceData('visible');
                  // }}
                  />
                }
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              style={{
                width: '100%',
                flex: '50%'
              }}
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(translationCache, 'Autopopulate Basis To The Equipment')}
                disabled={true}
                style={{ width: '70%' }}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.status)}
              name="JobPlanStatusId"
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true }]}
            >
              <Select
                placeholder={translation(translationCache, 'Select Status')}
                style={{ width: '32%' }}
              >
                {statusList.map((status, index) => {
                  return (
                    <Option key={index} value={status.Value}>
                      {' '}
                      {translation(translationCache, status.Key)}{' '}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            {/* <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.TaskType)}
              name="Type"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                disabled={formObject && formObject.Id ? true : false}
                placeholder={translation(translationCache, 'Select Task Type')}
                defaultValue={selectedTask}
                // onChange={(value) => onTaskSelection(value)}
                onChange={(value) => handleChange(value, 'Type')}
                notFoundContent={'Please Select DeviceCode For Tasks'}
              >
                <option value="observationType">
                  {translation(translationCache, constant.observationType)}
                </option>
                <option value="fieldDataType">
                  {translation(translationCache, constant.fieldDataType)}
                </option>
              </Select>
            </Form.Item> */}
            <Form.Item name="TaskName"></Form.Item>
            <Form.Item name="Equipment"></Form.Item>
          </div>
        </StyledBox>
        <StyledBox  themeBackground={themeBackground} style={{ padding: "20px" }}>
          <StyledSubHeading theme={themeSettings}>
            {translation(translationCache, 'Task Details')}
          </StyledSubHeading>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.addTask)}
              name="TaskName"
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Task')}
                multiple
                defaultValue={selectedTask}
                onChange={(value) => TaskOnChange(value)}
                notFoundContent={translation(translationCache, constant.selectEquipmentForTask)}
              >
                {TaskList &&
                  Array.isArray(TaskList) &&
                  TaskList.map((task, index) => {
                    return (
                      <Option
                        key={index}
                        disabled={
                          formHeader.current &&
                            formHeader.current.getFieldsValue() &&
                            formHeader.current.getFieldsValue().TaskData &&
                            formHeader.current
                              .getFieldsValue()
                              .TaskData.filter((item) => item.TaskName === task.TaskName).length > 0
                            ? true
                            : false
                        }
                        value={task.Id}
                      >
                        {task.TaskName}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }} name="TaskName">
              <InputComponent
                //maxLength={20}
                style={{ display: 'none' }}
              />
            </Form.Item>
          </div>
          <Form.List
            name="TaskData"
            rules={[
              {
                validator: async (_, TaskData) => {
                  if (!TaskData || TaskData.length === 0) {
                    return Promise.reject(new Error('At least 1 task'));
                  }
                }
              }
            ]}
          >
            {(fields) => (
              <>
                {fields && Array.isArray(fields) && fields.length > 0 ? (
                  <StyledCollapse theme={themeSettings} accordion defaultActiveKey={[]}>
                    {fields.map(({ key, name }, index) => (
                      <Panel
                        key={index}
                        header={styledCollapse(formObject, key, translationCache)}
                        extra={
                          <Popconfirm
                            title={translation(
                              translationCache,
                              'Are you sure that you want to delete the task？'
                            )}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            onConfirm={() => removeTask(key)}
                            okText={translation(translationCache, constant.yes)}
                            cancelText={translation(translationCache, constant.no)}
                          >
                            <Tooltip
                              title={translation(translationCache, 'Delete')}
                              placement="bottom"
                            >
                              <DeleteOutlined />
                            </Tooltip>
                          </Popconfirm>
                        }
                      >
                        <div>
                          <StyledSubForm theme={themeSettings} style={{ padding: '0px' }}>
                            <div>
                              <Form.Item
                                label={translation(translationCache, constant.attachments)}
                                name={[name, 'Attachments']}
                                style={{ width: '100%', flex: '50%' }}
                              >
                                <FileBase64
                                  disableAdd={
                                    formObject &&
                                      formObject.TaskData &&
                                      formObject.TaskData[index] &&
                                      formObject.TaskData[index].Id
                                      ? false
                                      : true
                                  }
                                  style={{ width: '50%' }}
                                  downloadClassName={'formdownloadInput'}
                                  Attachments={
                                    formObject &&
                                      formObject.TaskData &&
                                      formObject.TaskData[index] &&
                                      formObject.TaskData[index].Attachments
                                      ? formObject.TaskData[index].Attachments
                                      : []
                                  }
                                  fileUpload={(values, key, fileDataObject) => {
                                    taskFileupload(
                                      values,
                                      key,
                                      fileDataObject,
                                      index,
                                      formObject &&
                                        formObject.TaskData &&
                                        formObject.TaskData[index] &&
                                        formObject.TaskData[index].Id
                                        ? formObject.TaskData[index].Id
                                        : ''
                                    );
                                  }}
                                ></FileBase64>
                              </Form.Item>
                            </div>

                            <Tabs
                              defaultActiveKey="1"
                              type="card"
                            >
                              <TabPane tab={translation(translationCache, constant.tool)} key="1">
                                <Col span={24}>
                                  <Form.Item>
                                    <ToolsForm
                                      fieldKey={name}
                                      formObject={
                                        formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      onToolChange={handleSelect}
                                      onRemove={remove}
                                      onAdd={add}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                              <TabPane tab={translation(translationCache, constant.labor)} key="2">
                                <Col span={24}>
                                  <Form.Item>
                                    <LaborForm
                                      fieldKey={name}
                                      formObject={
                                        formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      onAdd={add}
                                      onRemove={remove}
                                      onLaborChange={handleSelect}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                              <TabPane tab={translation(translationCache, constant.material)} key="3">
                                <Col span={24}>
                                  <Form.Item>
                                    <MaterialForm
                                      fieldKey={name}
                                      formObject={
                                        formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      onAdd={add}
                                      onMaterialChange={handleSelect}
                                      onRemove={remove}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                              <TabPane tab={translation(translationCache, constant.items)} key="4">
                                <Col span={24}>
                                  <Form.Item>
                                    <ItemForm
                                      fieldKey={name}
                                      formObject={
                                        formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      onAdd={add}
                                      onRemove={remove}
                                      onItemChange={handleSelect}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                              <TabPane tab={translation(translationCache, 'Field Data Type')} key="5">
                                <Col span={24}>
                                  <Form.Item>
                                    <FieldDataType
                                      fieldKey={name}
                                      formObject={
                                        formHeader && formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      formHeader={formHeader}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                              <TabPane
                                tab={translation(translationCache, 'Observation Type')}
                                key="6"
                              >
                                <Col span={24}>
                                  <Form.Item>
                                    <ObservationType
                                      fieldKey={name}
                                      formObject={
                                        formHeader && formHeader.current !== null
                                          ? formHeader.current.getFieldsValue()
                                          : {}
                                      }
                                      // onObservationChange={handleSelect}
                                      formHeader={formHeader}
                                    />
                                  </Form.Item>
                                </Col>
                              </TabPane>
                            </Tabs>
                          </StyledSubForm>
                        </div>
                      </Panel>
                    ))}
                  </StyledCollapse>
                ) : null}
              </>
            )}
          </Form.List>

        </StyledBox>
      </Form>
      <StyledModal
        open={visible}
        width={1000}
        closable
        title={translation(translationCache, constant.selectEquipment)}
        onCancel={onDrawerCancel}
        onOk={onDrawerCancel}
      >
        <TableSelect
          data={tableData}
          translationCache={props.translationCache}
          key="DeviceCode"
          columns={[
            {
              title: translation(translationCache, 'Equipment'),
              dataIndex: 'DisplayCode',
              key: 'DisplayCode',
              ...getColumnSearchProps('DisplayCode')
            },
            {
              title: translation(translationCache, 'Equipment Description'),
              dataIndex: 'Name',
              key: 'Name',
              ...getColumnSearchProps('Name')
            }
          ]}
          handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
        />
        {/* <HierarchyModal
            value={state.deviceId}
            treeData={state.treeData}
            translationCache={props.translationCache}
            language={props.language}
            handleDropdownChange={hierarchyDropdownChange}
            deviceList={state.deviceList}
          /> */}
      </StyledModal>
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache
  };
};
export default connect(mapStateToProps)(JobPlanForm);
